export default __webpack_public_path__ + "static/media/img_change_certificate_label@2x.795099c4.png";